import { useContext, useState } from 'react';
import { PlaycastContext } from '../PlaycastWrapper';
import { Button } from '@playcastdotio/Shadcn';

export const Experimental = () => {
  const context = useContext(PlaycastContext);

  const [showVideo, setShowVideo] = useState(true);
  // const [showQrCode, setShowQrCode] = useState(true);

  // const toggleShowVideo = () => {
  //   context.targetFunctions.showVideo(!showVideo);
  //   setShowVideo(!showVideo);
  // };

  // const toggleShowQrCode = () => {
  //   context.targetFunctions.showQrCode(!showQrCode);
  //   setShowQrCode(!showQrCode);
  // };

  const setStaticImage = () => {
    context.targetFunctions.setStaticImage('https://placehold.co/600x400');
  };

  const handleUploadButtonClicked = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64 = e.target?.result as string;
          context.targetFunctions.setStaticImage(base64);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  return (
    <div>
      Experimental
      {/* <Button onClick={toggleShowVideo}>Toggle Show Video</Button> */}
      {/* <Button onClick={toggleShowQrCode}>Toggle Show QR Code</Button> */}
      <Button onClick={setStaticImage}>Set Static Image</Button>
      <Button onClick={handleUploadButtonClicked}>Upload Image</Button>
    </div>
  );
};
